var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Orígenes de oferta"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/origenOferta/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear origen ")],1)],1),_c('tabla',{attrs:{"origen-oferta":_vm.origenOferta},on:{"eliminar":_vm.eliminar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }